{
  "dodo.common.close": "Close",
  "dodo.common.continue": "Continue",
  "dodo.errors.idle.action": "Réessayer",
  "dodo.errors.idle.headline": "Service actuellement indisponible",
  "dodo.errors.idle.line1": "Veuillez réessayer plus tard.",
  "dodo.feedback.comments": "Please share any additional comments, suggestions or improvement opportunities. How it can be more valuable to you?",
  "dodo.feedback.description": "Your feedback is very important, so we can improve our services",
  "dodo.feedback.disclaimer.headline": "No worries, your answer will be anonymised!",
  "dodo.feedback.disclaimer.line1": "Your name and e-mail won't be linked to your answer.",
  "dodo.feedback.headline": "On a scale from 1-5, how satisfied are you with {subject}?",
  "dodo.feedback.placeholder": "Write your feedback here",
  "dodo.feedback.satisfied": "Very satisfied",
  "dodo.feedback.success.line1": "Thanks for using and contributing to our services.",
  "dodo.feedback.success.title": "Your feedback was successfully registered",
  "dodo.feedback.unsatisfied": "Very unsatisfied",
  "dodo.maintenance.actionText": "Retour à la page d'accueil",
  "dodo.maintenance.description": "Parfois, nous avons besoin d'une courte pause pour effectuer une maintenance essentielle et/ou des mises à niveau de nos services. Nous apprécions votre compréhension.",
  "dodo.maintenance.headline": "Désolé, nous sommes actuellement en maintenance planifiée"
}